import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getRiskAnalysisBySession } from "@/api/endpoints/riskAnalysis";
import type { RiskAnalysisBySession } from "@/types/risk-analysis";
import { queryKeys } from "../../../lib/queryClient";

export function useGetRiskAnalysisBySession(
  sessionId: string | undefined,
  config?: Omit<
    UseQueryOptions<RiskAnalysisBySession, Error>,
    "queryKey" | "queryFn"
  >
) {
  return useQuery<RiskAnalysisBySession, Error>({
    queryKey: queryKeys.riskAnalysis.bySession(sessionId || ""),
    queryFn: () => {
      if (!sessionId) {
        throw new Error("Session ID is required");
      }
      return getRiskAnalysisBySession(sessionId);
    },
    enabled: !!sessionId,
    staleTime: 0, // 5 minutes - data is considered fresh for this duration
    ...config,
  });
}
